import { deburr, escapeRegExp } from "lodash-es";
import { isDefined } from "./isDefined";

export const normalizedSearch = (hay?: string, needle?: string) =>
  isDefined(hay)
    ? deburr(hay.replaceAll("/", "")).match(
        new RegExp(escapeRegExp(deburr(needle?.replaceAll("/", ""))), "i"),
      )
    : null;
